module.exports = __webpack_public_path__ + "img/1.06ad58b4.svg";